import React from 'react'

import Icon from 'components/Icon'

// OPEN_TOAST reducer が content を Immutable の fromJS/toJS に通す際、
// React の検証済みフラグ（非列挙の _store.validated）が失われ再バリデーションで
// key 警告が出るため、静的な子要素にも明示的に key を付けている
export default (
  <div className="mx-5 my-4">
    <Icon
      key="finish-toast-icon"
      src="/assets/svgs/check-icon.svg"
      alt="check-icon"
      width="58px"
      height="58px"
      className="mb-3"
    />
    <div key="finish-toast-message">登録完了</div>
  </div>
)
